/**
 * OrbDocCommunityContributingAROrbDocCommunityContributingARPage
 *
 * Page component for OrbDocCommunityContributingAROrbDocCommunityContributingARPage
 * Path: /ar/docs/community/contributing
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCommunityContributingARDocScreenView as __OrbDocCommunityContributingARDocScreenView } from '@/components/traits/OrbDocCommunityContributingARDocScreenView';
import { OrbDocCommunityContributingARDocAnalyticsView as __OrbDocCommunityContributingARDocAnalyticsView } from '@/components/traits/OrbDocCommunityContributingARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCommunityContributingAROrbDocCommunityContributingARPageProps {
  // Add any page-level props here
}

export function OrbDocCommunityContributingAROrbDocCommunityContributingARPage(_props: OrbDocCommunityContributingAROrbDocCommunityContributingARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"المساهمة","description":"بلّغ عن المشكلات، وحسّن التوثيق، واقترح سلوكيات وترجمات.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/community/contributing"},{"locale":"ar","path":"/ar/docs/community/contributing"},{"locale":"sl","path":"/sl/docs/community/contributing"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCommunityContributingARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCommunityContributingARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCommunityContributingAROrbDocCommunityContributingARPage;
